export enum PuiInputType {
  Text = <any>'text',
  Number = <any>'number',
  Hidden = <any>'hidden',
  Password = <any>'password'
}
